import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import "react-table-6/react-table.css";

class Organization extends Component {
    constructor() {
        super();
        this.state = {
            file: null,
            fields: {},
            errors: {},
            showOrgForm: false,
            isFileSelected: false,
            showEditBtn: false,
            organizationId: '',
            editable: true,
            selectedLogo: '',
            logo: '',
            hideDeletePopup: false
        }
        this.settings = { effect: 'Zoom', duration: 400, delay: 0, position: 'center' };
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': (props) => {
                this.deleteOrgDetails()
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: false });
            }
        }];
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,
            });
        };

    }

    componentDidMount() {
        let thisController = this;
        setTimeout(() => {
            thisController.fetchOrgDataApi();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            thisController.fetchOrgDataApi();
        });
    }

    handleChange = (e) => {
        let fields = this.state.fields;
        fields[e.target.name] = e.target.value;
        this.setState({
            fields
        });
    }

    validateName = () => {
        let fields = this.state.fields;
        let errors = {};

        if (!fields["name"] || fields["name"].trim() == "") {
            errors["name"] = "*Please enter name";
        }
        this.setState({
            errors: errors
        });
    }

    validateAddress = () => {
        let fields = this.state.fields;
        let errors = {};

        if (!fields["address"] || fields["address"].trim() == "") {
            errors["address"] = "*Please enter address";
        }
        this.setState({
            errors: errors
        });
    }

    validateWebsiteAddress = () => {
        let field = this.state.fields;
        let errors = {};

        if (!field["website"] || field["website"].trim() == "") {
            errors["website"] = "*Please enter website address";
        }
        if (typeof field["website"] !== "undefined") {
            if (!field["website"].match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)) {
                errors["website"] = "*Please enter valid website address"
            }
        }
        this.setState({
            errors: errors
        });
    }

    validatePhoneNum = () => {
        let fields = this.state.fields;
        let errors = {};

        if (!fields["phoneNumber"] || fields["phoneNumber"].trim() == "") {
            errors["phoneNumber"] = "*Please enter phone number"
        }
        if (typeof fields["phoneNumber"] !== "undefined") {
            if (!fields["phoneNumber"].match(/^([0-9]){10}$/)) {
                errors["phoneNumber"] = "*Please enter valid phone number";
            }
        }
        this.setState({
            errors: errors
        });
    }

    validateGSTIN = () => {
        let field = this.state.fields;
        let errors = {};

        if (!field["gstin"] || field["gstin"].trim() == "") {
            errors["gstin"] = "*Please enter GSTIN";
        }
        if (typeof field["gstin"] !== "undefined") {
            if (!field["gstin"].match(/^(\d){2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/)) {
                errors["gstin"] = "*Please enter valid GSTIN";
            }
        }
        this.setState({
            errors: errors
        })
    }

    validatePAN = () => {
        let field = this.state.fields;
        let errors = {};

        if (!field["panNumber"] || field["panNumber"].trim() == "") {
            errors["panNumber"] = "*Please enter PAN";
        }
        if (typeof field["panNumber"] !== "undefined") {
            if (!field["panNumber"].match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)) {
                errors["panNumber"] = "*Please enter valid PAN";
            }
        }
        this.setState({
            errors: errors
        });
    }

    refreshData = () => {
        this.state.errors = {};
        this.setState(this.state);
        this.fetchOrgDataApi();
    }

    imagePreviewDataUrl(event) {
        let reader = new FileReader();
        reader.onloadend = () => {
            this.setState({
                file: reader.result
            });
        }
        if (event.target.files[0]) {
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    onChangeFile = (event) => {
        let orgController = this;
        let fileSize = (event.target.files[0].size) / 1000;
        if (fileSize < 512) {
            orgController.imagePreviewDataUrl(event);
            const fi = document.getElementById('logo');
            if (fi.files.length > 0) {
                orgController.setState({
                    selectedLogo: event.target.files[0]
                })
                let reader = new FileReader();
                reader.onloadend = () => {
                    orgController.setState({
                        isFileSelected: reader.result
                    });
                }
                reader.readAsBinaryString(event.target.files[0]);
            };
        } else {
            orgController.notifyImageSize();
        }
    }

    notifyImageSize() {
        document.getElementById("logo").value = '';
        toast(<b>File too Big, please select a file less than 512KB</b>, {
            position: "top-center",
        });
    }

    onChangeOrgSetting = (e) => {
        let orgController = this;
        orgController.state.showOrgForm = true;
        orgController.setState(orgController.state);
    }

    fetchOrgDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        let data = { projectId: projectId }
        let orgController = this;
        $.ajax({
            url: "/api/organisation-details",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                if (res.success === true) {
                    let imageUrl = res.result.logo.includes("data:image/png;base64") ? res.result.logo :
                        'data:' + res.result.logoType + ';base64,' + res.result.logo;
                    orgController.state.fields = res.result;
                    orgController.state.editable = false;
                    orgController.state.file = imageUrl
                    orgController.state.isFileSelected = imageUrl;
                    orgController.state.showEditBtn = true;
                    orgController.state.organizationId = res.result.id;
                    orgController.state.showOrgForm = true;
                    orgController.setState(orgController.state);
                    localStorage.setItem("organizationId", res.result.id)
                        ;
                } else {
                    if (document.getElementById("logo") != null) {
                        document.getElementById("logo").value = '';
                    }
                    orgController.state.fields = { name: '', address: '', website: '', phoneNumber: '', gstin: '', panNumber: '' };
                    var element = document.getElementById('isIntraState');
                    if (element != null) {
                        document.getElementById('isIntraState').checked = false;
                    }
                    orgController.state.errors = { name: '', address: '', website: '', phoneNumber: '', gstin: '', panNumber: '' };
                    orgController.state.isFileSelected = false;
                    orgController.state.file = null;
                    orgController.state.editable = true;
                    orgController.state.showEditBtn = false;
                    orgController.state.showOrgForm = false;
                    orgController.setState(orgController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    saveDetailsApi = () => {
        let orgController = this;
        if (orgController.validateOrgDetails()) {
            var imagePath = document.getElementById("logo").value;
            var imageUrl = this.state.isFileSelected;
            let data = {
                "name": this.state.fields.name,
                "address": this.state.fields.address,
                "website": this.state.fields.website,
                "phoneNumber": this.state.fields.phoneNumber,
                "gstin": this.state.fields.gstin,
                "panNumber": this.state.fields.panNumber,
                "logoType": this.state.selectedLogo.type,
                "logo": btoa(imageUrl),
                "isIntraState": document.getElementById("isIntraState").checked
            }
            $.ajax({
                url: "/api/organization-details",
                type: 'POST',
                async: false,
                headers: {
                    "Authorization": "Bearer" + localStorage.getItem("access_token"),
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(data),
                success: function (res) {
                    if (res.success === true) {
                        orgController.saveOrgToProjectApi(res.result.id);
                    } else {
                        orgController.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }

    saveOrgToProjectApi = (organizationId) => {
        let orgController = this;
        let data = {
            "projectId": localStorage.getItem("currentProjectId"),
            "organizationId": organizationId
        }
        $.ajax({
            url: "/api/project-organization-details",
            type: 'POST',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token"),
                "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
            },
            data: data,
            success: function (res) {
                if (res.success === true) {
                    orgController.state.errors = {};
                    orgController.notifySuccessToast("Added Successfully");
                    orgController.fetchOrgDataApi()
                    orgController.setState(orgController.state);
                } else {
                    orgController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    validateOrgDetails = () => {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        if (!fields["name"] || fields["name"].trim() == "") {
            errors["name"] = "*Please enter name";
            formIsValid = false;
        }

        if (!fields["address"] || fields["address"].trim() == "") {
            errors["address"] = "*Please enter address";
            formIsValid = false;
        }

        if (!fields["website"] || fields["website"].trim() == "") {
            errors["website"] = "*Please enter website address";
            formIsValid = false;
        }
        if (typeof fields["website"] !== "undefined") {
            if (!fields["website"].match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)) {
                errors["website"] = "*Please enter valid website address";
                formIsValid = false;
            }
        }

        if (!fields["phoneNumber"] || fields["phoneNumber"].trim() == "") {
            errors["phoneNumber"] = "*Please enter phone number";
            formIsValid = false;
        }
        if (typeof fields["phoneNumber"] !== "undefined") {
            if (!fields["phoneNumber"].match(/^([0-9]){10}$/)) {
                errors["phoneNumber"] = "*Please enter valid phone number";
                formIsValid = false;
            }
        }

        if (!fields["gstin"] || fields["gstin"].trim() == "") {
            errors["gstin"] = "*Please enter GSTIN";
            formIsValid = false;
        }
        if (typeof fields["gstin"] !== "undefined") {
            if (!fields["gstin"].match(/^(\d){2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/)) {
                errors["gstin"] = "*Please enter valid GSTIN";
                formIsValid = false;
            }
        }

        if (!fields["panNumber"] || fields["panNumber"].trim() == "") {
            errors["panNumber"] = "*Please enter PAN";
            formIsValid = false;
        }
        if (typeof fields["panNumber"] !== "undefined") {
            if (!fields["panNumber"].match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)) {
                errors["panNumber"] = "*Please enter valid PAN";
                formIsValid = false;
            }
        }

        if (this.state.file == null) {
            errors["logo"] = "*Please upload logo";
            formIsValid = false;
        }
        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    deleteOrgDetails = () => {
        let orgController = this;
        let projectId = localStorage.getItem("currentProjectId")
        $.ajax({
            url: "/api/organization-details/" + projectId,
            async: false,
            method: 'DELETE',
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },

            success: function (res) {
                if (res.success === true) {
                    orgController.setState({ hideDeletePopup: false });
                    orgController.notifySuccessToast("Deleted Successfully");
                    orgController.fetchOrgDataApi();
                } else {
                    orgController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });

    }

    notifySuccessToast(response) {
        toast.dismiss();
        toast(<b>
            <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }
    editOrgDetails = () => {
        this.state.editable = true;
        this.state.showEditBtn = false;
        this.setState(this.state);
    }

    updateOrgDetailsApi = () => {
        var imageUrl = this.state.isFileSelected;
        var btoaImage;
        btoaImage = imageUrl.includes("data:image/png;base64") ? imageUrl : btoa(imageUrl)
        let data = {
            "id": this.state.fields.id,
            "name": this.state.fields.name,
            "address": this.state.fields.address,
            "website": this.state.fields.website,
            "phoneNumber": this.state.fields.phoneNumber,
            "gstin": this.state.fields.gstin,
            "panNumber": this.state.fields.panNumber,
            "logoType": this.state.selectedLogo.type,
            "logo": btoaImage,
            "isIntraState": document.getElementById("isIntraState").checked
        }
        if (this.validateOrgDetails()) {
            let orgController = this;
            $.ajax({
                url: "/api/organization-details",
                type: 'PATCH',
                async: false,
                headers: {
                    "Authorization": "Bearer" + localStorage.getItem("access_token"),
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(data),
                success: function (res) {
                    if (res.success === true) {
                        orgController.state.errors = {};
                        orgController.notifySuccessToast("Updated Successfully");
                        orgController.fetchOrgDataApi();
                        orgController.setState(orgController.state);
                    } else {
                        orgController.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }

    render() {
        let $imagePreview = (<div className="previewText image-container" style={{ color: "black" }}>
            *file size should be less than 512KB<br /><br />
            <b>Note</b>:Supports only jpg,jpeg,png,svg,gif format</div>);
        if (this.state.isFileSelected) {
            $imagePreview = (<div className="image-container">
                {<img id="img" src={this.state.file} alt="icon" width="200" />}
            </div>);
        }
        return (
            <div>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />

                < ToastContainer className="Toast-at-center" />
                <div className="row">
                    <div className="col-sm-7">
                        <div className="row">
                            <div className="col-sm-3">
                                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px' }}>Organization Settings</h6>
                            </div>
                            <div className="col-sm-4" style={{ marginTop: '18px' }}>
                                <label class="switch">
                                    <input type="checkbox"

                                        onChange={this.onChangeOrgSetting}
                                        checked={this.state.showOrgForm}
                                    />
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-5" Align="right">
                        <button className="btn action-button" style={{ marginTop: "6px" }}
                            title="Refresh" onClick={this.refreshData}>
                            <img src="./assets/images/refresh_white_24dp.png" />
                        </button>
                    </div>
                </div>
                {/* /.card-header */}

                <div className="card-body p-0 mb-25"
                    style={{ display: this.state.showOrgForm ? "block" : "none" }}>
                    <div className="tab-content col-12 p-0">
                        <div className="card card-primary mt-3">
                            <div style={{ marginLeft: "30px", marginTop: "10px" }} className="raiseTicketLable">
                                <div Align='right' style={{ display: this.state.showEditBtn ? 'block' : 'none' }}>
                                    <button type="button" className="btn navyblue-btn" onClick={this.editOrgDetails}
                                        style={{ width: "7.5%", height: '30px', marginRight: "20px", marginTop: '10px' }}>
                                        Edit
                                    </button>
                                </div>
                                <div className="col-sm-12" style={{ marginTop: "10px" }}>
                                    <div className="col-sm-6">
                                        <div className="form-group ">
                                            <label>Name:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                                            <input
                                                type="text"
                                                name="name" placeholder="Enter Name"
                                                disabled={!this.state.editable}
                                                value={this.state.fields.name}
                                                onChange={this.handleChange}
                                                onBlur={this.validateName}
                                                style={{
                                                    padding: '0.375rem 0.75rem', width: '70%'
                                                }} />
                                            <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.name}</div>
                                        </div>
                                        <div className="form-group">
                                            <label>Website:&nbsp;&nbsp;&nbsp;&nbsp;</label>
                                            <input
                                                type="text"
                                                name="website" placeholder="Enter Website Address"
                                                value={this.state.fields.website}
                                                disabled={!this.state.editable}
                                                onChange={this.handleChange}
                                                onBlur={this.validateWebsiteAddress}
                                                style={{
                                                    padding: '0.375rem 0.75rem', width: '70%'
                                                }} />
                                            <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.website}</div>
                                        </div>
                                        <input type="checkbox"
                                            name="isIntraState"
                                            defaultChecked={this.state.fields.isIntraState}
                                            id="isIntraState"
                                            disabled={!this.state.editable}
                                            style={{
                                                marginLeft: '5px'
                                            }}
                                        />
                                        <label>Is gst registered in Karnataka</label>
                                        <div className="form-group">
                                            <label>GSTIN:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                                            <input
                                                type="text"
                                                name="gstin" placeholder="Enter Goods and Services Tax Identification Number"
                                                value={this.state.fields.gstin}
                                                disabled={!this.state.editable}
                                                onChange={this.handleChange}
                                                onBlur={this.validateGSTIN}
                                                style={{
                                                    padding: '0.375rem 0.75rem', width: '70%'
                                                }}
                                            />
                                            <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.gstin}</div>
                                        </div>
                                        <div className="form-group">
                                            <label>PAN:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                                            <input
                                                type="text"
                                                name="panNumber" placeholder="Enter PAN Card Number"
                                                value={this.state.fields.panNumber}
                                                onChange={this.handleChange}
                                                onBlur={this.validatePAN}
                                                disabled={!this.state.editable}
                                                style={{
                                                    padding: '0.375rem 0.75rem', width: '70%'
                                                }} />
                                            <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.panNumber}</div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group ">
                                            <label>Address:&nbsp;&nbsp;&nbsp;&nbsp;</label>
                                            <input
                                                type="text"
                                                name="address" placeholder="Enter Address"
                                                disabled={!this.state.editable}
                                                value={this.state.fields.address}
                                                onChange={this.handleChange}
                                                onBlur={this.validateAddress}
                                                style={{
                                                    padding: '0.375rem 0.75rem', width: '70%'
                                                }} />
                                            <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.address}</div>
                                        </div>
                                        <div className="form-group ">
                                            <label>Phone<br /> Number:&nbsp;&nbsp;&nbsp;&nbsp;</label>
                                            <input
                                                type="text"
                                                name="phoneNumber" placeholder="Enter Phone Number"
                                                value={this.state.fields.phoneNumber}
                                                disabled={!this.state.editable}
                                                onChange={this.handleChange}
                                                onBlur={this.validatePhoneNum}
                                                style={{
                                                    padding: '0.375rem 0.75rem', width: '70%', Align: 'right'
                                                }} />
                                            <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.phoneNumber}</div>
                                        </div>
                                        <div className="form-group">
                                            <label>Upload Logo</label>
                                            <div className="imgPreview">
                                                {$imagePreview}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div>
                                                <input id="logo" type="file" name="logo" accept="image/*"
                                                    disabled={!this.state.editable}
                                                    onChange={this.onChangeFile}
                                                />
                                                <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.logo}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group col-sm-12" Align="center" style={{ display: this.state.showEditBtn ? 'none' : 'block' }}>
                                    <label className="col-12 pull-left" />
                                    <button type="button" className="btn btn-primary navyblue-btn"
                                        style={{ width: "15%" }} onClick={this.state.fields.id === undefined ? this.saveDetailsApi
                                            : this.updateOrgDetailsApi}>Save</button>
                                    <button type="button" className="btn btn-primary navyblue-btn"
                                        style={{ width: "15%" }}
                                        onClick={() => {
                                            this.setState({
                                                hideDeletePopup: true,
                                            })
                                        }}
                                    >Delete</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <DialogComponent width='400px' style={{ marginTop: "150px", position: "fixed" }} animationSettings={this.settings}
                        header='Organization Details' showCloseIcon={true} buttons={this.buttons}
                        ref={dialog => this.dialogInstance = dialog}
                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                        <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                            content="" />&nbsp;Do you want to delete?<br />Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>
                </div>
            </div>
        );
    }
}
export default Organization;


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/team/Organization.js